export default {
  // INSTAGRAM SERVICE
  INSTAGRAM_GRAPH_API_HANDLE_AUTH: '/api/v1/instagrams/graph/api/handleAuth',
  INSTAGRAM_GRAPH_API_HANDLE_FB_LOGIN: 'api/v1/instagrams/graph/api/facebook-login',
  INSTAGRAM_GRAPH_API_HANDLE_SELECTION: '/api/v1/instagrams/graph/api/select',
  INSTAGRAM_GRAPH_API_CHECK_SESSION_AVAILBLE: '/api/v1/instagrams/graph/api/{fbId}/availble-session',
  INSTAGRAM_BASIC_DISPLAY_VERIFY: '/api/v1/instagrams/graph/api/basic-instagram-auth'
};



// WEBPACK FOOTER //
// ./src/config/APIs.js